import { ReactNode } from "react";
import { RootState, useSelector } from "../../../redux/store";
import { MessageProps } from "../../../typings/messages";
import NiceModal from "@ebay/nice-modal-react";
import { GenderType } from "../../../helpers/Enums";

export interface MessageTextProps {
   message: MessageProps;
   position: string;
   renderTicks: any;
   chatMemberImage: string | null;
   answerBreakTheIce: (data: any) => void;
   sendBreakTheIce: (data: any) => void;
}


const MessageBreakTheIce = ({ answerBreakTheIce, sendBreakTheIce, chatMemberImage, message, position, renderTicks }: MessageTextProps) => {
   const { revicerId, senderId, senderText, reciverText, question, questionId }: any = message.breakTheIce;
   const { profilePicture, memberCode, genderId: genderId } = useSelector((state: RootState) => state.member);

   const isMe = senderId === memberCode;
   const myMessage = isMe ? senderText : reciverText;
   const senderMessage = isMe ? reciverText : senderText;
   const isLocked = !(reciverText && senderText);

   const blurStyle: any = {
      color: "transparent",
      textShadow: "0 0 7px rgba(0,0,0,100%)",
      userSelect: "none"
   }

   const openBreakTheIceModal = (messageId: number | undefined) => {
      NiceModal.show("breakTheIce_modal", {
         handleNext: messageId ? answerBreakTheIce : sendBreakTheIce,
         messageId: messageId,
         questionTitle: question,
         questionId: questionId,
      });
   };

   const replayBreakTheIce = () => {
      if (!isMe && !reciverText) openBreakTheIceModal(message.messageId);
      else return;
   }

   const sender = (
      <div className="quest_talk_group">
         <img
            src={chatMemberImage ?? "/assets/images/user_bgr.svg"}
            loading="lazy"
            alt=""
            className="quest_talk_pict"
         />

         {
            isLocked ?
               <>
                  <img
                     src="/assets/images/ic_locker_w.svg"
                     loading="lazy"
                     alt=""
                     className="lock_talk"
                     style={{ marginBottom: 8 }}
                  />
                  {
                     senderMessage ?
                        <div className="buble_quest" style={{ ...blurStyle, textAlign: "right" }}>
                           <div>{senderMessage}</div>
                        </div>
                        : null
                  }

               </>
               :
               <div className="buble_quest">
                  <div>{senderMessage}</div>
               </div>
         }
      </div>
   )

   const reciver = (
      <div className="quest_talk_group flip">
         <img
            src={profilePicture ?? "/assets/images/user_bgr.svg"}
            loading="lazy"
            alt=""
            className="quest_talk_pict flip"
         />
         {
            !isMe && isLocked ?
               <div>
                  <img
                     src="/assets/images/ic_locker_w.svg"
                     loading="lazy"
                     alt=""
                     className="lock_talk flip"
                     style={{ marginBottom: 8 }}
                  />
                  <span className="chat_question_group info">&nbsp; {genderId === GenderType.MALE ? "לחץ" : "לחצי"} כאן כדי לענות </span>
               </div>
               :
               <div className="buble_quest flip" style={{ textAlign: 'right' }}>
                  <div>{myMessage}</div>

               </div>
         }

      </div>
   )

   return (

      <>
         <div onClick={replayBreakTheIce} className="responce_group">
            <div className="responce_block">
               <div className="chat_question_group info">
                  <div>שאלת שבור את הקרח:</div>
                  <div className="chat_question">{question}</div>
               </div>
               {
                  isMe ?
                     <>
                        {reciver}
                        {sender}
                     </>
                     :
                     <>
                        {sender}
                        {reciver}
                     </>
               }
            </div>
            <div className="responce_add_block">
               {
                  !isMe && !reciverText ?
                     <div style={{ fontWeight: "bold" }}>שליחת תשובה</div>
                     :
                     null
               }
               {
                  reciverText && senderText ?
                     <a onClick={() => openBreakTheIceModal(undefined)} href="#" className="response_addlink w-inline-block">
                        <img
                           src="/assets/images/ic_chat.svg"
                           loading="lazy"
                           alt=""
                           className="responce_add_icon"
                        />
                        <div>שליחת שאלה נוספת</div>
                     </a>
                     :

                     <div>התשובות יתגלו אחרי שכל צד יענה על השאלה</div>
               }


            </div>
         </div>
      </>
   )

}

export default MessageBreakTheIce;